import type { TranslationKey } from '../i18n/translation';
import { NcaLayerError } from '../signing/ncalayer-error';
import { describeApiError } from './describe-api-error';

/**
 * Why an ЭЦП signature did not go through: NCALayer on the customer's own computer, the certificate
 * the server checked, or anything the drawn path can also meet.
 */
export function describeSignatureError(error: unknown): TranslationKey {
    if (error instanceof NcaLayerError) {
        if (error.reason === 'unavailable') {
            return 'error.ncalayer_unavailable';
        }

        return error.reason === 'timeout' ? 'error.ncalayer_timeout' : 'error.ncalayer_failed';
    }

    return describeApiError(error);
}
